import { Container, Grid, Link } from "@mui/material";
import React, { useState , useEffect } from "react";
import DashBoardFooter from "../../../Components/DashboardFooter";
import Loader from "../../../Components/ErroBook/loader";
import ErrorBook from "../../../Components/ErroBook/ntErro"

import logo from "../../../images/logo.png"
import playtable_half from "../../../images/playtable_half.png"

const ForgetScreen = () => {
    const [useEmail, setEmail] = useState('');
    const [useEmailError, setEmailError] = useState(false);
    
    
    const [useLoader, setLoader] = useState(false);
    const [useError, setError] = useState(true);
    const [useErrorType, setErrorType] = useState('a');

    useEffect(()=> {
        setTimeout(() => {
            setError(false)
        }, 5000)
    },[useError]);

    const handleInput = ( e, type) => {
        if (type == 'mail') {
            let value = e.target.value;
            setEmail( value )
        }
    }
    const handleForget = () => {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; 
        
        if ( useEmail == "") {
            setErrorType("empty-email")
            setError(true)
            return;
        }else if ( !useEmail.match(pattern) ) {
            setErrorType("invalid-email")
            setError(true)
            return;
        }
        setError(false)
        
        setLoader(true)
        fetch('https://metasnooker.herokuapp.com/api/auth/recover',{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                email: useEmail,
            })
        })
        .then(response => response.json())
        .then( jsonData => {
            console.log('Response Data: ', jsonData)
            setLoader(false)
            setErrorType(jsonData.message)
            setError(true)
        })
    }
    return(
        <div className="AppDapp position-relative">
            { useLoader ? 
                <Loader />
                :
                <span />
            }
            <Container>
                <Grid
                    container
                    justifyContent='center'
                    alignContent="space-between"
                    className="div"
                >
                    <Grid
                        xs={12}
                        sm={8}
                        md={5}
                        lg={7}
                    ></Grid>
                    <Grid
                        xs={11}
                        sm={8}
                        md={7}
                        lg={5}
                        className="text-center mt-sm-5 pt-5"
                    >
                        <Link href="/" className="MS---dashboard--heading d-inline-block position-relative mb-5">
                            Forget Password
                        </Link>
                        {useError ?
                            <ErrorBook 
                                errorType = {useErrorType}
                            />
                        :
                            <span />
                        }
                        <div className="MS---dapp_form px-3 py-5 p-sm-5">
                            <form>
                                <label className="mb-2">Enter Email</label>
                                <input 
                                    type='email' 
                                    placeholder="Enter Email Address"
                                    className="mb-3"
                                    value={useEmail}
                                    onChange={(event,type) =>handleInput(event,'mail')}
                                />
                                <button
                                type="button"
                                    className="MS---Neon--Button btn d-inline-block mt-4 mb-5"
                                    onClick={handleForget}
                                >
                                    Send Code
                                </button>
                                <p className="mb-0">
                                    <Link href="/login" className="MS---pink-link">Back to Login</Link>
                                </p>
                            </form>
                            </div>
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        className="mt-sm-5 py-5 px-sm-5"
                    >
                        <Grid
                            xs={12}
                            sm={8}
                            className="text-center text-sm-left"
                        >
                            <p className="mb-0">Metasnooker © 2022. All Rights Reserved.</p>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={4}
                            className="text-center text-sm-right mt-4 mt-sm-0"
                        >
                            <Link href="/terms" className="MS---blue-link" target="_blank">
                                Terms & Conditions
                            </Link>
                            &nbsp;&nbsp;&nbsp;
                            <Link href="/privacy-policy" className="MS---blue-link" target="_blank">
                                Privacy Policy
                            </Link>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default ForgetScreen;